import { render, staticRenderFns } from "./FixedThead.vue?vue&type=template&id=a2f97202&"
import script from "./FixedThead.vue?vue&type=script&lang=js&"
export * from "./FixedThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f97202')) {
      api.createRecord('a2f97202', component.options)
    } else {
      api.reload('a2f97202', component.options)
    }
    module.hot.accept("./FixedThead.vue?vue&type=template&id=a2f97202&", function () {
      api.rerender('a2f97202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/table/dynamic-table/components/FixedThead.vue"
export default component.exports